import styled from 'styled-components';

type SwitchProps = {
  id?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  'aria-label'?: string;
};

/** iOS 스타일 on/off 토글 (checkbox 대체) */
export function Switch({
  id,
  checked,
  disabled,
  onChange,
  'aria-label': ariaLabel,
}: SwitchProps) {
  return (
    <Track
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      $on={checked}
      disabled={disabled}
      onClick={() => {
        if (!disabled) onChange(!checked);
      }}
    >
      <Thumb $on={checked} />
    </Track>
  );
}

const Track = styled.button<{ $on: boolean }>`
  position: relative;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: transparent;
  &::before {
    content: '';
    position: absolute;
    inset: 9px 0;
    border-radius: 999px;
    background: ${({ $on, theme }) =>
      $on ? theme.colors.primary : theme.colors.borderStrong};
    transition: background 0.18s ease;
  }
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.55 : 1)};
  transition: background 0.18s ease;
`;

const Thumb = styled.span<{ $on: boolean }>`
  position: absolute;
  top: 12px;
  left: ${({ $on }) => ($on ? '21px' : '3px')};
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: left 0.18s ease;
`;
